import React from 'react'

import { withAuth } from '../auth/withAuth';
import ChatTopicSelection from '../shared/Chat/ChatTopicSelection';

function LearnNewTopicTopicSelection() {
  return <ChatTopicSelection title="Learn a new Topic" navigationPath="learn-a-new-topic" />;
}
const LearnNewTopicTopicSelectionWithAuth = withAuth(LearnNewTopicTopicSelection);
export default LearnNewTopicTopicSelectionWithAuth;